<template>
  <div class="radio-container">
    <div class="radio-head">
      <span class="index">{{ title.sort }}.</span>
      <span class="type">(多选)</span>
      <van-field maxlength="50" v-model="title.name" placeholder="请输入题目内容" />
    </div>
    <div class="radio-body">
      <van-checkbox-group @change="checkedBoxChange" v-model="optionActiveValue" :disabled="!title.isCorrect">
        <van-checkbox
          shape="square"
          label-disabled
          v-for="(option, index) in title.options"
          :key="index"
          :name="option.id"
        >
          <van-field maxlength="50" v-model="option.content" />
          <i @click.stop="hanldeDelOption(index)" v-if="index > 1" class="iconfont iconshanchu"></i>
        </van-checkbox>
      </van-checkbox-group>

      <div @click="addOption" class="radio-add-options">
        <i class="iconfont iconshanchu"></i>
        <span>添加选项</span>
      </div>
      <div class="radio-control">
        <van-checkbox @change="correctAnswerChange" v-model="correctAnswer">正确答案</van-checkbox>
        <van-checkbox @change="mustAnswerChange" v-model="mustAnswer">必填</van-checkbox>
        <div @click="handleDelTitle" class="radio-del">
          <span class="icon"><i class="iconfont icon-del"></i></span>
          <span class="label">删除</span>
        </div>
      </div>
    </div>
    <div class="radio-footer">
      <div @click="changeSort('-')">
        <i class="iconfont icon-arrow"></i>
        <span>上移题目</span>
      </div>
      <div @click="changeSort('+')">
        <i class="iconfont icon-arrow down"></i>
        <span>下移题目</span>
      </div>
    </div>
  </div>
</template>

<script>
import {uuid} from '@/ultis'
export default {
  props: ['title'],
  data() {
    return {
      optionActiveValue: [],
      correctAnswer: false,
      mustAnswer: false
    }
  },
  watch: {
    title: {
      handler(val) {
        if (val) {
          const {isCorrect, isMandatory, options} = val
          if (isCorrect === 1) {
            this.correctAnswer = true
            options.forEach(option => {
              if (option.isCorrect === 1) {
                this.optionActiveValue.push(option.id)
              }
            })
          } else {
            this.correctAnswer = false
          }
          if (isMandatory === 1) {
            this.mustAnswer = true
          } else {
            this.mustAnswer = false
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    changeSort(type) {
      this.$emit('change-sort', {
        type,
        index: this.title.sort - 1
      })
    },
    handleDelTitle() {
      this.$emit('on-del', this.title.sort - 1)
    },
    // ============
    hanldeDelOption(index) {
      this.title.options.splice(index, 1)
      /* 重置sort */
      this.title.options = this.title.options.map((item, index) => ({...item, sort: index + 1}))
    },
    addOption() {
      this.title.options.push({
        isCorrect: 0,
        content: '选项',
        sort: this.title.options.length + 1,
        id: uuid()
      })
    },
    checkedBoxChange(name) {
      this.title.options.forEach(option => {
        const id = option.id
        if (name.indexOf(id) !== -1) {
          option.isCorrect = 1
        } else {
          option.isCorrect = 0
        }
      })
    },
    correctAnswerChange(checked) {
      if (checked) {
        this.title.isCorrect = 1
      } else {
        this.optionActiveValue = []
        this.title.isCorrect = 0
      }
    },
    mustAnswerChange(checked) {
      this.title.isMandatory = checked ? 1 : 0
    }
  }
}
</script>

<style scoped lang="scss">
.radio-container {
  background: #fff;
  margin: 12px 0;
}
.radio-head {
  display: flex;
  align-items: center;
  padding: 0 10px;
  span {
    flex-shrink: 0;
  }
  span.index {
    margin-right: 10px;
  }
  span.type {
    color: #c0c4cc;
  }
}

.radio-body {
  padding: 12px;
  border-top: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;

  .radio-add-options {
    color: #4465f3;
    padding: 16px 0;
    // display: flex;
    // align-items: center;
    display: inline-block;
    i {
      position: relative;
      top: 2px;
      font-size: 22px;
      display: inline-block;
      transform: rotate(45deg);
      margin-right: 10px;
    }
  }
  .radio-control {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .radio-del {
      .icon {
        display: inline-block;
        width: 28px;
        height: 28px;
        background: #e23c43;
        border-radius: 50%;
        text-align: center;
        line-height: 28px;
        color: #fff;
      }
      .label {
        color: #909399;
        margin-left: 8px;
      }
    }
  }
}

.radio-footer {
  height: 50px;
  display: flex;
  div {
    flex: 1;
    line-height: 50px;
    text-align: center;
    color: #909399;
  }
  i.down {
    display: inline-block;
    transform: rotate(180deg);
  }
}
</style>
<style lang="scss">
.radio-container {
  .van-checkbox {
    position: relative;
    padding-right: 30px;
    display: flex;
    .van-checkbox__label {
      color: #909399;
      flex: 1;
      .van-cell {
        padding: 10px 0;
      }
      .van-cell::after {
        position: static;
      }
      i {
        position: absolute;
        right: 4px;
        top: 50%;
        font-size: 20px;
        transform: translateY(-50%);
        color: #e23c43;
      }
    }
  }
  .van-checkbox__label {
    color: #909399;
  }
  .van-radio__label {
    color: #909399;
  }
}
</style>
